import { render } from "./vs-result.vue?vue&type=template&id=3981c10c&scoped=true&ts=true"
import script from "./vs-result.vue?vue&type=script&lang=ts"
export * from "./vs-result.vue?vue&type=script&lang=ts"

import "./vs-result.vue?vue&type=style&index=0&id=3981c10c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3981c10c"]])

export default __exports__